import React from "react";
import { Charges } from "../../components/Charges";
import { withRouter } from "../../utils/withRouter";
import { connect } from "react-redux";
import { DashboardHeader } from "../../components/Header";
class ChargesScreen extends React.Component {
  render() {
    const { searchParams } = this.props;

    const accountId = searchParams.get("accountId");
    const accountName = searchParams.get("accountName");
    return (
      <div className="card">
        <div className="card-body">
          <DashboardHeader
            title={accountName + " charges"}
            titleClassName="text-primary"
          />
          <Charges accountId={accountId} />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const { defaultLanguage } = state.Language;
  return {
    defaultLanguage,
  };
};

export default connect(mapStateToProps)(withRouter(ChargesScreen));
